import { useState } from 'react';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { AGGREGATED_COLUMNS } from '../constants';

const handleDownloadCSV = (rows, pageInfo, columnGroups) => {
  const dCSV = new Date()
  const csvConfig = mkConfig({
    filename: `${pageInfo}_${dCSV.getFullYear()}-${dCSV.getMonth()+1}-${dCSV.getDate()}_${dCSV.getHours()}-${dCSV.getMinutes()}-${dCSV.getSeconds()}`,
    useKeysAsHeaders: true
  })

  let tableData = []
  for (const row of rows) {
    let rowData = {}
    // Remove 'Show on map' column and Expand toggle column if necessary
    const cells = row.getVisibleCells().filter(cell => !['Expand', ''].includes(cell.column.columnDef.header))
    for (const cell of cells) {
      if (row.getIsGrouped()) {
        if ([...AGGREGATED_COLUMNS, row.groupingColumnId].includes(cell.column.columnDef.id)) {
          rowData[cell.column.columnDef.header] = cell.getValue()
        } else {
          rowData[cell.column.columnDef.header] = undefined
        }
      } else {
        if (row.parentId) {
          const parentGroups = columnGroups.filter(col => row.parentId.includes(col));
          if (parentGroups.includes(cell.column.columnDef.id)) {
            rowData[cell.column.columnDef.header] = undefined
          } else {
            rowData[cell.column.columnDef.header] = cell.getValue()
          }
        } else {
          rowData[cell.column.columnDef.header] = cell.getValue()
        }
      }
    }
    tableData.push(rowData)
  }
  const csv = generateCsv(csvConfig)(tableData);
  download(csvConfig)(csv);
}

const handleDownloadPDF = (rows, pageInfo, columnGroups) => {
    const dPDF = new Date()
    let tableData = []
	for (const row of rows) {
		let rowData = []
		// Remove 'Show on map' column and Expand toggle column if necessary
		const cells = row.getVisibleCells().filter(cell => !['Expand', ''].includes(cell.column.columnDef.header))
		for (const cell of cells) {
		  if (row.getIsGrouped()) {
			if ([...AGGREGATED_COLUMNS, row.groupingColumnId].includes(cell.column.columnDef.id)) {
			  rowData.push(cell.getValue())
			} else {
			  rowData.push(undefined)
			}
		  } else {
			if (row.parentId) {
			  const parentGroups = columnGroups.filter(col => row.parentId.includes(col));
			  if (parentGroups.includes(cell.column.columnDef.id)) {
				rowData.push(undefined)
			  } else {
				rowData.push(cell.getValue())
			  }
			} else {
			  rowData.push(cell.getValue())
			}
		  }
		}
		tableData.push(rowData)
	}
    const visibleColumns = rows[0]
        .getVisibleCells()
        .filter(cell => !['Expand', ''].includes(cell.column.columnDef.header))
        .map(cell => cell.column.columnDef.header)

    const doc = new jsPDF({
        orientation: 'landscape',
    })
    autoTable(doc, {
        head: [visibleColumns],
        body: tableData,
        horizontalPageBreak: true,
		horizontalPageBreakRepeat: columnGroups.length > 0 ? columnGroups.map((_, index) => index) : undefined,
        tableWidth: 'wrap',
        styles: {
        cellWidth: 'wrap',
        },
    })
    doc.save(`${pageInfo}_${dPDF.getFullYear()}-${dPDF.getMonth()+1}-${dPDF.getDate()}_${dPDF.getHours()}-${dPDF.getMinutes()}-${dPDF.getSeconds()}`)
}

export default function TableDownloadButton({table, category}) {
    const tableName = table.refs.tablePaperRef.current?.id ?? ''
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)
    const handleDownloadClick = (event) => {
      setAnchorEl(event.currentTarget)
    }
    const handleDownloadClose = () => {
      setAnchorEl(null)
    }

    return (
        <>
          <Tooltip title='Download data'>
            <span>
              <IconButton
                id='download-data-button'
                onClick={handleDownloadClick}
                aria-controls={open ? 'download-data' : undefined}
                aria-haspopup='true'
                aria-expanded={open ? 'true' : undefined}
                disabled={table === undefined || table === null || table.getRowCount() === 0}
              >
                <FileDownloadIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            id='download-data'
            open={open}
            onClose={handleDownloadClose}
            onClick={handleDownloadClose}
            style={{ height: 'auto' }}
            MenuListProps={{
              'aria-labelledby': 'download-data-button',
            }}
          >
            {/* <MenuItem onClick={() => handleDownloadCSV(
                table.getState().grouping.length > 0 ? table.getRowModel().rows : table.getPrePaginationRowModel().rows,
                `${tableName}_All_Pages`,
                table.getState().grouping
            )}>
              Download CSV (all pages)
            </MenuItem> */}
            <MenuItem onClick={() => handleDownloadCSV(
                table.getRowModel().rows,
                `${tableName}_Page_${table.getState().pagination.pageIndex+1}`,
                table.getState().grouping
            )}>
              Download CSV (current page)
            </MenuItem>
            {/* <MenuItem onClick={() => handleDownloadPDF(
                table.getState().grouping.length > 0 ? table.getRowModel().rows : table.getPrePaginationRowModel().rows,
                `${tableName}_All_Pages`,
                table.getState().grouping
            )}>
              Download PDF (all pages)
            </MenuItem> */}
            <MenuItem onClick={() => handleDownloadPDF(
                table.getRowModel().rows,
                `${tableName}_Page_${table.getState().pagination.pageIndex+1}`,
                table.getState().grouping
            )}>
              Download PDF (current page)
            </MenuItem>
          </Menu>
        </>
    )
}